import getOrgAlias from '@shootsta/get-alias';
import globalConfig from 'react-global-configuration';

export function redirectToSingleLogout() {
  const ssoApiEndpoint = String(globalConfig.get('ssoApiEndpoint'));

  window.location.href = `${ssoApiEndpoint}logout?al=${getOrgAlias()}`;
}